import {UIUrlParameterNames} from './UIUrlController'

export abstract class UIManagerEvents {
    abstract createClickedJoinRoomCallback(gameId: string): Promise<void>
    abstract isSceneLobby(): boolean
    abstract isSceneGame(): boolean
    abstract leaveRoomAndJoinRoom(roomId: string)
    abstract handleUrlRedirectViaParameters(parameter: UIUrlParameterNames, parameterValue: any)
    abstract premiumMembershipCheckAction()
}
